"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var flattenFragment = function (children) {
    var flatten = function (clrn) {
        return react_1.Children.map(clrn, function (child) {
            if (!react_1.isValidElement(child))
                return child;
            if (child.type === react_1.Fragment)
                return flatten(child.props.children);
            return child;
        });
    };
    return flatten(children);
};
exports.default = flattenFragment;
